export default /* html */ `
<p><slot></slot></p>
`
